import { render, staticRenderFns } from "./DwdcblrForm.vue?vue&type=template&id=1616a261&scoped=true"
import script from "./DwdcblrForm.vue?vue&type=script&lang=js"
export * from "./DwdcblrForm.vue?vue&type=script&lang=js"
import style0 from "./DwdcblrForm.vue?vue&type=style&index=0&id=1616a261&prod&lang=scss&scoped=true"
import style1 from "./DwdcblrForm.vue?vue&type=style&index=1&id=1616a261&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1616a261",
  null
  
)

export default component.exports